import { format } from 'date-fns';
import React from 'react';

import { Colors, TextVariants } from '@lichtblick/theme';

import { CalendarAppointment } from './CalendarAppointment';
import { ContentWrapper, ShowItem, ShowText } from './InstallationCalendar.styles';
import { CalendarEvent } from './type';

import { PopoverComponent, Text } from '..';

export const CustomShowMore = ({
  count,
  handleEventClick,
  remainingEvents,
  slotDate,
}: {
  count: number;
  handleEventClick: (event: CalendarEvent) => Promise<void>;
  remainingEvents: CalendarEvent[];
  slotDate: Date;
}) => {
  return (
    <PopoverComponent
      align="center"
      content={
        <ContentWrapper>
          <Text>{format(slotDate, 'dd. MMMM yyyy')}</Text>
          {remainingEvents.map((event: CalendarEvent) => (
            <ShowItem key={event.id} onClick={() => handleEventClick(event)}>
              <CalendarAppointment event={event} />
            </ShowItem>
          ))}
        </ContentWrapper>
      }
      trigger={<ShowText $variant={TextVariants.body.xs} color={Colors.blue[100]}>{`+${count} more`}</ShowText>}
    />
  );
};
